export default "__VITE_ASSET__JN25FHWY__"